import { render, staticRenderFns } from "./PlayGround.vue?vue&type=template&id=854b5f54&"
import script from "./PlayGround.vue?vue&type=script&lang=ts&"
export * from "./PlayGround.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports